





























































import Vue from "vue";
import Component from "vue-class-component";
import { Action, Getter } from "vuex-class";
import { Emit, Watch } from "vue-property-decorator";
import UserInterface from "@/types/app/IUser";

import Header from "@/types/app/header";
import applyCondition from "@/utils/applyCondition";
import { formatDateWithTime } from "@/utils/formatDate";
import { truncate } from "@/utils/truncate";
import CompanyService from "@/services/companyService";
import Company, { companyInitialValue } from "@/types/app/companies";
import CustomerCompany from "@/components/headers/customer-companies";
import BaseComponent from "@/utils/baseComponent";
import RefreshStore from "@/services/refreshStore";
const namespace = "company";

@Component({
  methods: {
    formatDateWithTime,
    truncate,
  },
})
export default class Companies extends BaseComponent {
  @Getter("getModalCompanyState", { namespace })
  modalCompanyState!: boolean;

  @Action("setModalCompanyState", { namespace })
  setModalCompanyState!: any;
  @Getter("getUser", { namespace: "auth" }) user!: UserInterface;

  private companyService = new CompanyService(this.$http);
  formatDateWithTime = formatDateWithTime;
  loadingCompanies = false;
  headers: Header[] = CustomerCompany.header;
  selectedCompanies: any[] = [];
  companyNameFilter = "";
  companies: Company[] = [];

  async mounted() {
    await this.handleCompanies();
  }

  async handleCompanies() {
    this.loadingCompanies = true;
    this.companies = await this.companyService.getCompanies();
    this.loadingCompanies = false;
  }

  get filteredCompanies() {
    const conditions: any[] = [];
    if (this.companyNameFilter) {
      conditions.push((item: Company) =>
        item.name.toLowerCase().includes(this.companyNameFilter.toLowerCase())
      );
    }

    return applyCondition<Company>(this.companies, conditions);
  }

  showCompany(company: Company) {
    this.$router.push({
      name: "CompanyFormView",
      params: {
        companyId: company.id,
        formType: 'view'
      }
    });
  }

  async showImport() {
    this.$router.push({
      name: "CompanyImport"
    });
  }

  async deleteCompanies() {
    this.loadingCompanies = true;
    try {
      await this.$confirm(`Do you really want to delete (${this.selectedCompanies.length}) companies?`).then(
        async (res) => {
          if (res) {
            const companiesId = this.selectedCompanies.map(x => x.id);
            const data = await this.companyService.deleteCompanies(companiesId);

            if (!data.hasErrors) {
              this.companies = this.companies.filter(x => companiesId.find(y => y == x.id) == null)
            }
            this.selectedCompanies = [];
          }
        });
    }
    finally {
      this.loadingCompanies = false;
    }

  }

  get hasSelectToDelete() {
    return this.selectedCompanies.length > 0;
  }


  showNewCompanyModal() {
       this.$router.push({
      name: "CompanyFormNew",
      params: {
        formType: "new"
      },
    });
  }

  async exportCsv() {
    const newArr = this.companies.sort(
      (a, b) => new Date(a.updatedDate).getTime() - new Date(b.updatedDate).getTime()
    );
    this.exportCSVFile([...newArr], `Companies-export`);
  }
}
